import type { Bundle, Lesson, StageState } from "@otto/lehrgang";
import { ExerciseLine } from "./ExerciseLine.js";
import { FingerHint } from "./FingerHint.js";
import { Keyboard } from "./Keyboard.js";
import { modifierFor, modifierName } from "../lib/modifier.js";
import styles from "./practice.module.css";
import own from "./PracticeCard.module.css";

export function PracticeCard({
  bundle,
  lesson,
  stage,
  state,
  expected,
  lastKey,
  missCount,
  shaking,
  onShakeEnd,
  fingerName,
  onKey,
  wayHint,
}: {
  bundle: Bundle;
  lesson: Lesson;
  stage: Lesson["stages"][number];
  state: StageState;
  expected: string | null;
  lastKey: string | null;
  missCount: number;
  shaking: boolean;
  onShakeEnd: () => void;
  fingerName: string | null;
  onKey: (key: string, modifiers?: { readonly shiftKey?: boolean }) => void;
  /** Steht da, wenn der letzte Fehler am Weg zum Großbuchstaben lag. */
  wayHint: string | null;
}) {
  const modifier = modifierFor(bundle, lesson, expected);

  return (
    <div className={styles.card}>
      <p className={own.hint}>{stage.hint}</p>

      <ExerciseLine
        state={state}
        missCount={missCount}
        shaking={shaking}
        onShakeEnd={onShakeEnd}
      />

      <FingerHint
        expected={expected}
        fingerName={fingerName}
        modifier={modifierName(modifier)}
      />

      {/* Der Buchstabe war richtig, nur der Weg nicht. Ohne diesen Satz bliebe
          nur ein stummes Wackeln, und das Kind sucht den Fehler beim Buchstaben.

          Über der Tastatur, im Blickfeld zwischen Zeile und Tasten - unterhalb
          der Tastatur liegt er auf dem iPad außerhalb des Bildes. */}
      {wayHint && <p className={own.wayHint}>{wayHint}</p>}

      <Keyboard
        bundle={bundle}
        lesson={lesson}
        expected={expected}
        lastKey={lastKey}
        onKey={onKey}
        modifier={modifier}
      />

      {/* Counters instead of a percentage: "right" and "mistyped" are more
          tangible for a child — and the number should not push for speed. */}
      <div className={own.counters}>
        <span>
          Richtig: <b className={own.hits}>{state.correct}</b>
        </span>
        <span>
          Vertippt: <b className={own.misses}>{state.errors}</b>
        </span>
      </div>
    </div>
  );
}
